'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _temp;

var _redux = require('redux');

var _reactRouterRedux = require('react-router-redux');

var _seamlessImmutable = require('seamless-immutable');

var _seamlessImmutable2 = _interopRequireDefault(_seamlessImmutable);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = require('fbjs/lib/warning');

var _warning2 = _interopRequireDefault(_warning);

var _messages = require('../core/messages');

var _messages2 = _interopRequireDefault(_messages);

var _action = require('./action');

var _modelToReducer = require('./modelToReducer');

var _modelToReducer2 = _interopRequireDefault(_modelToReducer);

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

var _extractModules = require('../core/extractModules');

var _extractModules2 = _interopRequireDefault(_extractModules);

var _saga = require('./saga');

var _saga2 = _interopRequireDefault(_saga);

var _baseModel = require('../damo/baseModel');

var _baseModel2 = _interopRequireDefault(_baseModel);

var _reducerImmediate = require('./reducerImmediate');

var _reducerImmediate2 = _interopRequireDefault(_reducerImmediate);

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _crud = require('../damo/crud');

var _crud2 = _interopRequireDefault(_crud);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reduxShape = {
  ajax: _propTypes2.default.object,
  initialState: _propTypes2.default.object,
  middlewares: _propTypes2.default.array,
  name: _propTypes2.default.string,
  Models: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func])
};

var guid = 1;
var ReduxSeed = (_temp = _class = function () {
  (0, _createClass3.default)(ReduxSeed, null, [{
    key: 'createModel',


    /**
     * ### 静态方法
     *
     * | 名称 | 参数类型 | 描述 |
     * | :------ | :------ | :------ |
     * | createModel | model `Object`, resource `Object` | 组合resource到model中，等同于Beatle.createModel |
     * | getRedux | name `String` | 获取指定的seed实例 |
     */
    value: function createModel(Model, Resource) {
      Model.actions = Model.actions || {};
      (0, _forEach2.default)(Resource, function (exec, actionName) {
        if (Model.actions[actionName]) {
          Model.actions[actionName].exec = exec;
        } else {
          Model.actions[actionName] = {
            exec: exec,
            callback: function callback(nextStore, payload) {
              return payload.data;
            }
          };
          if (Model.prototype instanceof _baseModel2.default && !Model.prototype[actionName]) {
            Model.prototype[actionName] = function () {
              for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              var promise = this.execute.apply(this, [actionName, { exec: exec }, true].concat(args));
              var feedback = exec.successMessage || exec.errorMessage ? _crud2.default.message(exec.successMessage, exec.errorMessage) : function () {};
              promise.then(function (ret) {
                if (ret instanceof Error) {
                  feedback(ret);
                } else {
                  feedback(null, ret);
                }
              }, function (err) {
                feedback(err);
              });
              return this.fromPromise(promise);
            };
          }
        }
      });
      return Model;
    }
  }, {
    key: 'getRedux',
    value: function getRedux(name) {
      if (ReduxSeed.multiCfgs[name]) {
        return ReduxSeed.multiCfgs[name];
      } else {
        (0, _warning2.default)(false, _messages2.default.invalidValue, 'arguments', 'name', name, 'Beatle.ReduxSeed.getRedux', Object.keys(ReduxSeed.multiCfgs));
      }
    }

    /**
     * 初始化配置项
     *
     * | 属性 | 描述 | 默认 |
     * |:------ |:------ |:------ |
     * | name `String` | ReduxSeed支持多实例，初始化一个seed实例需要指定实例名称 | `main` |
     * | ajax `Object` | ajax实例 | N/A |
     * | initialState `Object` | store的基础结构 | `{}` |
     * | middlewares `Array` | 应用数据处理中间件，通过中间件可以变更数据结果 | `[]` |
     * | Models `Object` | 注册多个数据模型 | `{}` |
     */

  }]);

  function ReduxSeed() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, ReduxSeed);

    _propTypes2.default.checkPropTypes(reduxShape, options, 'ReduxSeedOptoins', 'Beatle.ReduxSeed');

    this._instanceName = options.name || ReduxSeed.defaultApp;
    this._ajax = options.ajax;
    this._saga = new _saga2.default();
    this._isImmutable = options.freeze || options.initialState === undefined || _seamlessImmutable2.default.isImmutable(options.initialState);
    this._pureReducers = [];
    this._pureReducers.state = {};
    this._incrementReducerState = {
      __uuid__: guid
    };
    this._init(this._instanceName);
    var initialState = this._isImmutable && options.initialState ? options.initialState.asMutable({ deep: true }) : options.initialState;
    this._initStore(initialState, options.middlewares.concat(this._saga.getMiddleware(this.getModel.bind(this))), options.Models);
  }

  (0, _createClass3.default)(ReduxSeed, [{
    key: 'increment',
    value: function increment() {
      this._incrementReducerState.__uuid__ = ++guid;
    }
  }, {
    key: '_init',
    value: function _init() {
      if (ReduxSeed.multiCfgs[this._instanceName]) {
        (0, _warning2.default)(false, _messages2.default.duplicate, 'initRedux', 'Beatle.ReduxSeed');
      } else {
        ReduxSeed.multiCfgs[this._instanceName] = {
          models: {},
          resources: {},
          store: null,
          rootReducer: {
            routing: _reactRouterRedux.routerReducer
          },
          actions: {}
        };
      }
    }
  }, {
    key: '_initStore',
    value: function _initStore() {
      var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _this = this;

      var middlewares = arguments[1];
      var Models = arguments[2];

      initialState['__pure_reducer__'] = this._pureReducers.state;
      initialState['__increment_reducer__'] = this._incrementReducerState;
      (0, _store2.default)(initialState, middlewares, function () {
        return _this.reducerBuilder(Models);
      }, function (store) {
        var effects = _this._saga.effect();
        for (var key in effects) {
          store.runSaga(effects[key]);
        }
        ReduxSeed.getRedux(_this._instanceName).store = store;
      });
    }
  }, {
    key: '_setModel',
    value: function _setModel(redux, name, Model, Resource) {
      var _this2 = this;

      if (!redux.models[name]) {
        if (!Model.displayName) {
          Model.displayName = name;
        }
        if (Model.prototype instanceof _baseModel2.default) {
          Model = new Model({
            name: Model.displayName,
            ajax: this._ajax,
            actions: Model.actions,
            isImmutable: this._isImmutable,
            saga: this._saga
          });
          Model.actions = {};
        }
        Object.defineProperty(Model, 'dispatch', {
          get: function get() {
            return _this2.getStore().dispatch;
          },
          enumerable: false
        });
        var store = Model.state = Model.state || Model.store || {};
        var initialState = this._isImmutable ? (0, _seamlessImmutable2.default)(store) : store;

        redux.models[name] = Model;
        redux.actions[name] = (0, _action.getActions)({
          modelName: name,
          model: Model,
          resource: Resource,
          initialState: initialState
        }, this);

        redux.rootReducer[name] = (0, _modelToReducer2.default)(Model, initialState, this._isImmutable);
        return store;
      }
    }
  }, {
    key: 'get',
    value: function get(name) {
      return ReduxSeed.getRedux(this._instanceName)[name];
    }
  }, {
    key: 'subscribe',
    value: function subscribe(callback) {
      var redux = ReduxSeed.getRedux(this._instanceName);
      return redux.store.subscribe(function () {
        return callback(redux.store.getState());
      });
    }
  }, {
    key: 'dispatch',
    value: function dispatch(action) {
      var redux = ReduxSeed.getRedux(this._instanceName);
      if (Object(action) === action && !action.type) {
        action.type = '__pure_reducer__';
      }
      return redux.store.dispatch(action);
    }

    /**
     * ### ReduxSeed的实例方法
     *
     * | 名称 | 参数类型 | 描述 |
     * | :------ | :------ | :------ |
     * | serialize(obj) `Object` | obj `Object` | 序列化数据结构，此时数据为不可变 |
     * | deserialize(obj) `Object` | obj `Object` | 反序列化数据结构，以方便对数据进行更改 |
     * | reducerBuilder | model `Object`, resource `Object` | 组合resource到model中，等同于Beatle.createModel |
     * | register | model `Object`, resource `Object` | 注册一个model到seed实例 |
     * | getActions | modelName `String` | 获取指定的seed实例下的model的行为，为空时获取所有行为 |
     */

  }, {
    key: 'serialize',
    value: function serialize(obj) {
      if (obj !== undefined && !obj.asMutable) {
        return (0, _seamlessImmutable2.default)(obj);
      } else {
        return obj;
      }
    }
  }, {
    key: 'deserialize',
    value: function deserialize(obj, deep) {
      if (obj !== undefined && obj.asMutable) {
        return obj.asMutable({ deep: deep });
      } else {
        return obj;
      }
    }
  }, {
    key: 'reducerBuilder',
    value: function reducerBuilder(Models) {
      var _this3 = this;

      var redux = ReduxSeed.getRedux(this._instanceName);
      Models = Models && (0, _extractModules2.default)(Models);
      for (var name in Models) {
        this._setModel(redux, name, Models[name]);
      }
      redux.rootReducer['__increment_reducer__'] = function () {
        return {
          __uuid__: _this3._incrementReducerState.__uuid__
        };
      };
      redux.rootReducer['__pure_reducer__'] = function () {
        var nextStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this3._pureReducers.state;
        var action = arguments[1];

        if (_this3._pureReducers.length) {
          var newStore = {};
          _this3._pureReducers.forEach(function (obj) {
            if (obj.name) {
              if (obj.name === action.name) {
                Object.assign(newStore, obj.reducer(nextStore, action.payload));
              }
            } else {
              Object.assign(newStore, obj.reducer(nextStore, action.payload));
            }
          });
          return (0, _reducerImmediate2.default)(nextStore, newStore, '');
        }
        return nextStore;
      };
      return (0, _redux.combineReducers)(redux.rootReducer);
    }
  }, {
    key: 'getStore',
    value: function getStore() {
      return ReduxSeed.getRedux(this._instanceName).store;
    }
  }, {
    key: 'getModel',
    value: function getModel(name) {
      return ReduxSeed.getRedux(this._instanceName).models[name];
    }
  }, {
    key: 'register',
    value: function register(Model, Resource) {
      var redux = ReduxSeed.getRedux(this._instanceName);
      if ((typeof Model === 'undefined' ? 'undefined' : (0, _typeof3.default)(Model)) === 'object' || Model.prototype instanceof _baseModel2.default) {
        var name = Model.displayName;
        var initialState = this._setModel(redux, name, Model, Resource);
        if (initialState) {
          var rootReducer = (0, _redux.combineReducers)(redux.rootReducer);
          redux.store.replaceReducer(rootReducer);
          var effects = this._saga.effect(name);
          if (effects) {
            redux.store.runSaga(effects);
          }
          var allState = redux.store.getState();
          allState[name] = initialState;
        }
      } else {
        if (typeof Model === 'function') {
          this._pureReducers.push({
            reducer: Model
          });
        } else if (typeof Model === 'string' && typeof Resource === 'function') {
          this._pureReducers.push({
            name: Model,
            reducer: Resource
          });
          if (arguments[2] !== undefined) {
            this._pureReducers.state[Model] = arguments[2];
          }
        }
      }
    }
  }, {
    key: 'getActions',
    value: function getActions(name) {
      var redux = ReduxSeed.getRedux(this._instanceName);
      if (name) {
        return redux.actions[name];
      } else {
        return redux.actions;
      }
    }
  }]);
  return ReduxSeed;
}(), _class.defaultApp = 'main', _class.multiCfgs = {}, _temp);
exports.default = ReduxSeed;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/seed/index.js
// module id = 55
// module chunks = 0